import React from "react";




import  '../../../public/styles/pdpComponent/pdpComponent.scss';

class productUnavailable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

    formSubmitHandler = () => {
      window.open("https://www.godrejinterio.com/","_self");
    };

    render() {
      const { } = this.state;
      return (   
        window.location.assign('/')      
        //   <div className="">
        //      {!isMobile() ? (
        //         <img className="" src="/imagestore/images/godrejInterio/product-unavailable.webp" alt="sofa"/>
        //      ) : ( 
        //         <img className="" src="/imagestore/images/godrejInterio/product-unavailable-rwd.webp" alt="sofa-rwd"/>
        //      )}
        //       <p className="unavailable-text1">{UNAVAILABLE_CURRENTLY}</p>
        // <p className="unavailable-text2">{UNAVAILABLE_EXPLORE_SIMILAR}</p>
        //         <Button
        //         className="submit-btn btn-block btn-bg product-unavailable"
        //         onClick={this.formSubmitHandler}> {UNAVAILABLE_BROWSER_SIMILAR}
        //         </Button>              
        //   </div>
      );
    }
}
export default productUnavailable;
